import { getReseller, IReseller } from '@grupoboticario/barril-del-chavo'
import { QueryClient } from '@tanstack/react-query'
import { LoaderFunctionArgs, redirect } from 'react-router-dom'
import { BrandName } from 'src/@enums'
import { getConfig } from 'src/helpers'

export const redirectToHome = () => {
  return redirect('/')
}

const queryKey = ['reseller']

const defaultResponse = new Response(null, { status: 200 })
export const redirectIfOldReseller =
  (queryClient: QueryClient) =>
  async ({ params }: LoaderFunctionArgs) => {
    const config = getConfig()
    const resellerSlug = params.reseller

    const isNotEudoraBrand = config.brandEnv !== BrandName.EUDORA
    const isInvalidOrGenericSlug = !resellerSlug || resellerSlug === config.genericUser.catalogSlug

    if (isNotEudoraBrand || isInvalidOrGenericSlug) {
      return defaultResponse
    }

    const resellerDetails = (await queryClient.fetchQuery({
      queryKey,
      queryFn: () =>
        getReseller({
          resellerSlug,
          businessUnit: config.businessUnit,
        }),
      staleTime: Infinity,
    })) as IReseller & { vdfSlug?: string }

    const isNotEligibleForRedirect = resellerDetails?.isVdf || !resellerDetails?.vdfSlug

    if (!resellerDetails || isNotEligibleForRedirect) {
      return defaultResponse
    }

    queryClient.invalidateQueries(queryKey)

    return redirect(`/${resellerDetails.vdfSlug}`)
  }
